// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Components
import './components'

// Plugins
import './plugins'

// Sync router with store
import { sync } from 'vuex-router-sync'

// Application imports
import App from './App'
import i18n from '@/i18n'
import router from './router'
import store from '@/store'
import 'chart.js'


import firebase from 'firebase';
import '@/components/firebase.init';

import SocialSharing from 'vue-social-sharing'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMailBulk } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faTwitter, faWhatsapp } from '@fortawesome/fontawesome-free-brands'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faMailBulk, faFacebook, faTwitter, faWhatsapp);


Vue.use(SocialSharing);
Vue.component('fa-icon', FontAwesomeIcon);
// Sync store with router
// sync(store, router)

Vue.config.productionTip = false
let app;
/* eslint-disable no-new */
firebase.auth().onAuthStateChanged(()=>{
  if(!app){
    app = new Vue({
      i18n,
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})

